import { Module } from "vuex";

import { IRootState } from "@/store";
import { getters } from "@/store/modules/notification/getters";
import { actions } from "@/store/modules/notification/actions";
import { mutations } from "@/store/modules/notification/mutations";
import { INotificationState, state } from "@/store/modules/notification/state";

export const notification: Module<INotificationState, IRootState> = {
  actions,
  mutations,
  state,
  getters,
};
